import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './TableHead.module.scss';

function TableHead({ children, className, ...remainingProps }) {
  return (
    <thead
      className={classNames(styles.root, className)}
      {...remainingProps}
    >
      {children}
    </thead>
  );
}

TableHead.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default TableHead;
